var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown',{on:{"command":_vm.doCommand}},[_c('el-button',{attrs:{"size":"mini","icon":"el-icon-more","circle":""}}),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"reply"}},[_vm._v("Reply")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }